<template>
  <article
    :class="{ 'load load--fill min-h-screen': isLoading }"
    class="card"
  >
    <header
      v-if="!isLoading && calendarEvent"
      class="text-center py-3"
    >
      <h1
        class="text-grey-darkest text-lg"
        v-text="calendarEvent.attributes.title"
      />
      <a
        target="_blank"
        rel="noopener noreferrer"
        :href="`https://www.google.com/maps/place/${calendarEvent.attributes.location}`"
        v-text="calendarEvent.attributes.location"
      />
      <p v-if="calendarEvent.attributes.all_day">
        {{ allDayDate }} <b v-text="' | All Day'" />
      </p>
      <p
        v-else
        v-html="multiDayDate"
      />
      <a
        target="_blank"
        rel="noopener noreferrer"
        :href="calendarEvent.attributes.web_link"
        v-text="calendarEvent.attributes.web_link"
      />
      <CommPopper
        ref="commPopper"
        v-can="['edit-calendar-events', 'delete-calendar-events']"
        :options="{ placement: 'bottom-end' }"
      >
        <div
          slot="content"
          class="flex flex-col"
        >
          <a
            v-can="'edit-calendar-events'"
            :href="editUrl"
            v-text="'Edit'"
          />
          <a
            v-can="'delete-calendar-events'"
            href="#"
            @click.prevent="
              $refs.commPopper
                .close()
                .then(
                  $store.commit(
                    'calendarOpenDeleteCalendarEventModal',
                    calendarEvent
                  )
                )
            "
            v-text="'Delete'"
          />
        </div>
      </CommPopper>
    </header>
    <div
      v-if="!isLoading && calendarEvent"
      class="card-content mx-auto"
    >
      <div
        v-if="calendarEvent.attributes.image"
        class="mb-8 card-header-image"
      >
        <img
          :alt="calendarEvent.attributes.title"
          :src="calendarEvent.attributes.image.url"
        >
      </div>
      <span
        class="js-fitvids"
        v-html="details"
      />
    </div>
    <DeleteCalendarEventModal
      :calendar-event-uuid="calendarEventUuid"
      @destroyed="redirect"
    />
  </article>
</template>

<script type="text/babel">
import CommPopper from 'Communication/Resources/assets/js/components/CommPopper'
import DeleteCalendarEventModal from './_modals/DeleteCalendarEventModal'
import anchorme from 'anchorme'

export default {
  name: 'CalendarEventDetails',
  components: {
    CommPopper,
    DeleteCalendarEventModal,
  },
  props: {
    calendarEventUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      calendarEvent: null,
    }
  },
  computed: {
    editUrl() {
      return this.$urlGenerator.active(
        `calendar/events/${this.calendarEventUuid}/edit`
      )
    },
    allDayDate(){
      if (this.calendarEvent.attributes.is_dates_on_the_same_day) {
        return this.$date.toMomentDateFormat(this.startDate)
      }

      return `${this.$date.toMomentDateFormat(this.startDate)} - ${this.$date.toMomentDateFormat(this.endDate)}`
    },
    multiDayDate(){
      if (this.calendarEvent.attributes.is_dates_on_the_same_day) {
        return `${this.$date.toMomentDateFormat(this.startDate)} | ${this.$date.toMomentTimeFormat(this.startDate)} - ${this.$date.toMomentTimeFormat(this.endDate)}`
      }

      return `<b>from</b> ${this.$date.toMomentDateTimeFormat(this.startDate)} <b>to</b> ${this.$date.toMomentDateTimeFormat(this.endDate)}`
    },
    startDate() {
      return this.calendarEvent.attributes.start_date
    },
    endDate(){
      return this.calendarEvent.attributes.end_date
    },
    details(){
      return anchorme(this.calendarEvent.attributes.details)
    },
  },
  async created() {
    await this.$nextTick()

    this.isLoading = true

    this.$api
      .active()
      .get('calendar/events/' + this.calendarEventUuid)
      .then((response) => {
        this.calendarEvent = response.data
        this.isLoading = false
      })
  },
  methods: {
    redirect() {
      window.location.replace(this.$urlGenerator.active('calendar'))
    },
  },
}
</script>
